import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utility/axiosInstance';

export const fetchBillingHistory = createAsyncThunk(
    'billingHistory/fetch',
    async (page: number, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/v1/billing/history?page=${page}&limit=3`);
            // Ensure we return an array even if data is empty
            return Array.isArray(response.data) ? response.data : [];
        } catch (err) {
            // This triggers the 'rejected' case
            return rejectWithValue("Failed to load history");
        }
    }
);

const billingHistorySlice = createSlice({
    name: 'billingHistory',
    initialState: {
        months: [] as any[],
        page: 1,
        hasMore: true,
        status: 'idle' as 'idle' | 'loading' | 'succeeded' | 'failed',
    },
    reducers: {
        resetHistory: (state) => {
            state.months = [];
            state.page = 1;
            state.hasMore = true;
            state.status = 'idle';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBillingHistory.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchBillingHistory.fulfilled, (state, action) => {
                state.status = 'succeeded';

                // Defensive check: Only proceed if we have an array
                if (Array.isArray(action.payload)) {
                    // Filter out any potentially malformed records before adding to state
                    const newMonths = action.payload.filter(m => m && m.month);

                    state.months = [...state.months, ...newMonths];

                    // Logic: If we received fewer items than our limit (3), we know we've reached the end
                    if (action.payload.length < 3) {
                        state.hasMore = false;
                    } else {
                        state.page += 1;
                    }
                }
            })
            .addCase(fetchBillingHistory.rejected, (state) => {
                state.status = 'failed';
                // Stop trying to load more if the connection is failing
                state.hasMore = false;
            });
    }
});

export const { resetHistory } = billingHistorySlice.actions;
export default billingHistorySlice.reducer;